




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import ErrorAlert from "@/utility/ErrorAlert";
import { appModule } from "@/store/modules/app";
import storeModalTtd from "@/store/modules/ModalTandaTangan";

@Component({})
export default class ModalTandaTangan extends Vue {
  password = "";
  showEye = false;
  rules = {
    required: (value) => !!value || "Required.",
  };

  msg = "";

  get show() {
    return storeModalTtd.show;
  }

  get document() {
    return storeModalTtd.document;
  }

  get document_id() {
    return storeModalTtd.document_id;
  }

  get input() {
    return {
      document: this.document,
      document_id: this.document_id,
      password: this.password,
    };
  }

  get saving() {
    return storeModalTtd.saving;
  }

  sign() {
    storeModalTtd.SET_SAVING(true);

    setTimeout(() => {
      storeModalTtd.SET_SAVING(false);
      this.close();
    }, 2000);
  }

  close() {
    this.password = null;
    storeModalTtd.closeModal();
  }
}
